var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('FreshChatLauncher',_vm._g({directives:[{name:"show",rawName:"v-show",value:(_vm.initializeChat),expression:"initializeChat"}],on:{"closeChat":_vm.handleCloseChat}},_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }